import React from 'react'

const AddActionIcon: React.FC = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.16667 4.16667H5.83333V0.833333C5.83333 0.583333 5.75 0.416667 5.58333 0.25C5.41667 0.0833333 5.25 0 5 0C4.75 0 4.58333 0.0833333 4.41667 0.25C4.25 0.416667 4.16667 0.583333 4.16667 0.833333V4.16667H0.833333C0.583333 4.16667 0.416667 4.25 0.25 4.41667C0.0833333 4.58333 0 4.75 0 5C0 5.25 0.0833333 5.41667 0.25 5.58333C0.416667 5.75 0.583333 5.83333 0.833333 5.83333H4.16667V9.16667C4.16667 9.41667 4.25 9.58333 4.41667 9.75C4.58333 9.91667 4.75 10 5 10C5.25 10 5.41667 9.91667 5.58333 9.75C5.75 9.58333 5.83333 9.41667 5.83333 9.16667V5.83333H9.16667C9.41667 5.83333 9.58333 5.75 9.75 5.58333C9.91667 5.41667 10 5.25 10 5C10 4.75 9.91667 4.58333 9.75 4.41667C9.58333 4.25 9.41667 4.16667 9.16667 4.16667Z"
      fill="#0970E6"
    />
  </svg>
)

export default AddActionIcon
